import { BasketballSwitchRequest } from '@hefe/models';
import { BasketballSwitchRequestsSlice, ModalsSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useAppDispatch } from '../../../store/store';
import CustomForm from '../../core/components/form/custom-form';

interface SwitchRequestsSwitchSimpleFormProps {
  request: BasketballSwitchRequest;
  userId: number;
}

export default function SwitchRequestsSwitchSimpleForm(
  props: SwitchRequestsSwitchSimpleFormProps
) {
  const { request, userId } = props;
  const dispatch = useAppDispatch();

  const onSubmit = (values: any) => {
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setModalLoading(true));

    dispatch(
      BasketballSwitchRequestsSlice.takeOverBasketballSwitchRequest({
        id: request.id,
        new_user_id: userId,
      })
    )
      .unwrap()
      .then(() => dispatch(ModalsSlice.modalsActions.closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <Space direction="vertical" size={20}>
      <Typography.Text>
        {t('questions.ask_take_over_with_date', {
          date: formatDateTime(request.event_date),
        })}
      </Typography.Text>
      <CustomForm
        formId={`switch-request-form-${request.id}`}
        fields={[]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
